import { type ExtractPropTypes, computed, type PropType } from 'vue';

import type { BreakpointType } from '../../typings/breakpointType';
import { BreakpointDepended } from '../breakpointDepended';

export function withTextClipProps(defaultValue?: number | { [key in BreakpointType]?: number }) {
  return {
    /**
     * Maksymalna liczba wierszy która wyświetli się przed ucięciem tekstu.
     */
    textClip: {
      type: [Number, Object] as PropType<number | { [key in BreakpointType]?: number }>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca style ucinania tekstu
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useTextClipProps = (props: ExtractPropTypes<ReturnType<typeof withTextClipProps>>) => {
  return computed(() => {
    const textClipStyle = computed(() => {
      return `   
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: ${props.textClip};
          line-clamp: ${props.textClip};
          -webkit-box-orient: vertical;`;
    });

    if (!props.textClip) {
      return;
    }

    if (typeof props.textClip === 'number') {
      return textClipStyle;
    }

    if (BreakpointDepended(props.textClip).value) {
      return textClipStyle;
    }

    return;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesTextClipArgs = {
  args: {
    textClip: undefined
  },

  argTypes: {
    textClip: {
      control: { type: 'number' }
    }
  }
};
